import { useState, useEffect } from "react";
import Calendar from "./weekcalendar/Calendar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import { getUserInfo, isAuthenticated, clearCookies } from "./Auth";
import { toast } from "react-toastify";
import {endpoint} from './config';

import logo from "./assets/images/brand-logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Home = () => {
  const [calendarDate, setCalenderDate] = useState(new Date());
  const [userInfo, setUserInfo] = useState([]);
  const [employee, setEmployee] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    //console.log(isAuthenticated());
    if (isAuthenticated()) {
      if(getUserInfo().userType!=="Employee"){
        navigate("/");
      }
      
      setUserInfo(getUserInfo());
    } else {
      navigate("/login");
    }
  }, [navigate]);

  useEffect(() => {
    //fetchEmployee();
  }, []);

  async function fetchEmployee() {
    const user = getUserInfo();

    const response = await axios.get(
      `${endpoint}/employee/${user.emailId}` 
    );
    const data = response.data;
    //console.log(data);
    if (data.status) {
      const emp = data.data;
      setEmployee(emp);
      //console.log(emp);
    } else {
      toast("Please login with correct Employee Account.");
      console.log(data.message);
    }
  }

  const logout = () => {
    //Cookies.remove("access_token");
    //Cookies.remove("userInfo");
    clearCookies();
    navigate("/login");
  };
  return (
    <>
    {isAuthenticated() ? "" : <Navigate to={"/login"} />}

    <header className="nav-bar bg-light bd-navbar sticky-top">
        <nav className="container flex align-center justify-between">
          <div className="navbar-toggle">
            <button
              className="navbar-toggler p-2"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#bdSidebar"
              aria-controls="bdSidebar"
              aria-label="Toggle docs navigation"
            >
              <FontAwesomeIcon icon={"bars"}/>
              <span className="d-none fs-6 pe-1">Browse</span>
            </button>
          </div>

          <div className="brand-logo">
            <Link to={"/"}>
              <img src={logo} alt="Attitude Crafters Logo" className="brand-logo"></img>
            </Link>
          </div>

          <div className="nav-menu flex flex-1 align-center">
            <div className="flex">
              <div className="name ml-2">{userInfo.userName}</div>
            </div>
          </div>
          <div className="flex align-center">
            <div className="name d-none mr-2">{userInfo.userName}</div>
            <button type="button" className="btn btn-light" onClick={logout}>
              Logout
            </button>
          </div>
        </nav>
      </header>

      <div className="container mt-3">
        <div className="card">
          <div className="card-body">
          <Calendar
            value={calendarDate}
            onChange={setCalenderDate}
          />
          </div>
        </div>

      </div>

      <footer className="footer">
        <div className="poweredby text-center">
          Powered by{" "}
          <a rel="noreferrer" href="http://technixindia.com" target={"_blank"}>
            Technix India Solutions (P) Limited
          </a>
        </div>
      </footer>

    </>
  );
};

export default Home;
